import React, { useEffect, useState } from 'react';

const getApiBaseUrl = () => {
    const baseUIUrl = window.location.host;
    switch (baseUIUrl) {
        case "simpra.com":
        case "ipd.simpra.com":
        case "formulary.simpra.com":
            return process.env.REACT_APP_API_PROD_BASE_URL;
        default:
            return process.env.REACT_APP_API_DEV_BASE_URL;
    }
}

const badgeStyle: React.CSSProperties = {
    position: 'fixed',
    top: '11%',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
    background: 'crimson',
    color: 'white',
    borderRadius: '8px',
    width: '100px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    fontSize: '0.9rem',
    cursor: 'default',
    userSelect: 'none'
};

const DisplayEnvironment: React.FC = () => {
    const [environment, setEnvironment] = useState<string>("");

    useEffect(() => {
        fetch(`${getApiBaseUrl()}Environment`)
            .then((res) => res.json())
            .then((data) => setEnvironment(data.environment));
    }, []);
    if (!environment) return (
        <div style={{ position: 'fixed', background: "green", padding: '8px', textAlign: "center" }}>
            <strong>No Environment Added</strong>
        </div>
    )

    if (environment != 'Development') return null;

    return (
        <div style={badgeStyle}>
            {environment}
        </div>
    )
}

export default DisplayEnvironment;